const cookies = () => ({
    cookieConsent: false,
    analytics: false,
    adStorage: false,
    init() {
        this.cookieConsent = window.Alpine.store('cookies').consent

        // If user has consented, load the options, otherwise leave as defaults
        if (this.cookieConsent) {
            this.analytics = this.getCookieOption('analytics') ?? this.analytics
            this.adStorage = this.getCookieOption('adStorage') ?? this.adStorage
        }
        // Populate options into store. Every instance of this component does
        // this on every page load, so it must not announce a choice.
        this.saveCookieOptions(false)
    },
    rejectCookies() {
        this.cookieConsent = true
        this.analytics = false
        this.adStorage = false
        this.saveCookieOptions()
    },
    toggleOption(option) {
        this[option] = !this[option]
        this.saveCookieOptions()
    },
    // cookies-accepted means "the visitor has just made a choice": the gtm
    // component and Tag Manager's consent relay both act on it. Only the
    // visitor's own actions send it; init() passes notify = false.
    saveCookieOptions(notify = true) {
        window.Alpine.store('cookies').consent = this.cookieConsent

        window.Alpine.store('cookies').options = [
            { name: 'analytics', value: this.analytics },
            { name: 'adStorage', value: this.adStorage },
        ]

        if (notify && this.cookieConsent) {
            window.dispatchEvent(new CustomEvent('cookies-accepted'))
        }
    },
    getCookieOption(option) {
        if (!window.Alpine.store('cookies')?.consent) {
            return false
        }

        const cookie = window.Alpine.store('cookies')?.options?.find((o) => o.name === option)

        return cookie?.value
    },
    showOptionModal() {
        window.Alpine.store('general').showCookieOptionModal = true
        window.Alpine.store('general').showOverlay = true
    },
})
document.addEventListener('alpine:init', () => {
    window.Alpine.data('cookies', cookies)
})
export default cookies
